import { ComponentIndex } from './component_index';
import { EntitiesEngine } from './entities_engine';
import { EntitiesFilter, FilterMask } from './entities_filter';
import { bitMask, bitMaskNot, BITS_PER_MASK } from '../utils/bitmask.helpers';

export class Entity {
  private readonly _components: any[];
  private readonly _filter: EntitiesFilter = new EntitiesFilter(new FilterMask(0, 0));
  private readonly _oldFilter: EntitiesFilter = new EntitiesFilter(new FilterMask(0, 0));
  private readonly entitiesEngine: EntitiesEngine;

  constructor(entitiesEngine: EntitiesEngine) {
    this.entitiesEngine = entitiesEngine;
    this._components = [];
    for (let i = 0; i < entitiesEngine.componentCount; i++) {
      this._components.push(null);
    }
  }

  public get filter(): EntitiesFilter {
    return this._filter;
  }

  public set filter(value: EntitiesFilter) {
    if (this._filter !== value) {
      this._oldFilter.mask.mask1 = this._filter.mask.mask1;
      this._oldFilter.mask.mask2 = this._filter.mask.mask2;
      this._filter.mask.mask1 = value.mask.mask1;
      this._filter.mask.mask2 = value.mask.mask2;
      this.entitiesEngine.filterChange(this);
    }
  }

  public get oldFilter(): EntitiesFilter {
    return this._oldFilter;
  }

  public hasComponent(index: ComponentIndex): boolean {
    const component = this._components[index.componentIndex];
    return component !== null && component !== undefined;
  }

  public get<T>(index: ComponentIndex): T {
    return this._components[index.componentIndex] as T;
  }

  public set(index: ComponentIndex, component: any): void {
    this._components[index.componentIndex] = component;
  }

  public register(): void {
    this.entitiesEngine.registerEntity(this);
  }

  public unregister(): void {
    this.entitiesEngine.unregisterEntity(this);
  }

  public addComponent<T>(componentName: string, component: T): ComponentIndex {
    this._oldFilter.mask.mask1 = this._filter.mask.mask1;
    this._oldFilter.mask.mask2 = this._filter.mask.mask2;
    const index: ComponentIndex = this.entitiesEngine.getComponentIndex(componentName);
    const idx = index.componentIndex;
    const newMask = new FilterMask(0, 0);
    if (index.componentIndex < BITS_PER_MASK) {
      newMask.mask1 = bitMask(idx);
      newMask.mask2 = this._filter.mask.mask2;
    } else {
      newMask.mask1 = this._filter.mask.mask1;
      newMask.mask2 = bitMask(idx % BITS_PER_MASK);
    }
    this._filter.mask = this._filter.mask.or(newMask);
    this._components[idx] = component;
    if (this.entitiesEngine.getAllEntities().list.includes(this)) {
      this.entitiesEngine.filterChange(this);
    }
    return index;
  }

  public removeComponent(componentName: string): void {
    this._oldFilter.mask.mask1 = this._filter.mask.mask1;
    this._oldFilter.mask.mask2 = this._filter.mask.mask2;
    const index: ComponentIndex = this.entitiesEngine.getComponentIndex(componentName);
    const idx: number = index.componentIndex;
    const newMask: FilterMask = new FilterMask(0, 0);
    if (index.componentIndex < BITS_PER_MASK) {
      newMask.mask1 = bitMaskNot(idx);
      newMask.mask2 = this._filter.mask.mask2;
    } else {
      newMask.mask1 = this._filter.mask.mask1;
      newMask.mask2 = bitMaskNot(idx % BITS_PER_MASK);
    }
    this.filter.mask = this.filter.mask.and(newMask);
    this._components[idx] = null;
    if (this.entitiesEngine.getAllEntities().list.includes(this)) {
      this.entitiesEngine.filterChange(this);
    }
  }
}
